/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  GetDashboardReportCall,
  GetMapReportCall,
} from "../../redux/api/report.api";
import SimpleMap from "./components/SimpleMap";
import { isEmpty } from "lodash";

function Dashboard() {
  const report = useSelector((state) => state?.report?.report);

  const androidUsers = report?.platform?.android;
  const iOSUsers = report?.platform?.ios ?? 0;
  const iosSubscriptions = report?.platform?.iosSubscriptions ?? 0;
  const androidSubscriptions = report?.platform?.androidSubscriptions ?? [];
  const annuallyRegistration = report?.registration ?? [];
  const last7DaysRegistration = report?.last7Days ?? [];
  const sales = report?.sales ?? [];
  console.log("pippo androidUsers", androidUsers);

  useEffect(() => {
    GetDashboardReportCall();
    GetMapReportCall();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="apple"
                title="iOS Users"
                count={iOSUsers}
                percentage={{
                  color: "success",
                  // amount: "+55%",
                  label: "Total number",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="android"
                title="Android Users"
                color="success"
                count={androidUsers}
                percentage={{
                  color: "success",
                  label: "Total number",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="apple"
                title="iOS Subscriptions"
                count={iosSubscriptions}
                percentage={{
                  color: "success",
                  label: "iOS Subscriptions",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="android"
                title="Android Subscriptions"
                count={androidSubscriptions}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              {!isEmpty(last7DaysRegistration) && (
                <MDBox mb={3}>
                  <ReportsBarChart
                    color="info"
                    title="Registrations"
                    description={
                      <>
                        (<strong>{annuallyRegistration?.percentage}%</strong>)
                        Compared to previous month
                      </>
                    }
                    date="just updated"
                    chart={last7DaysRegistration}
                  />
                </MDBox>
              )}
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              {!isEmpty(annuallyRegistration) && (
                <MDBox mb={3}>
                  <ReportsLineChart
                    color="success"
                    title="Annually Registrations"
                    description={
                      <>
                        (<strong>{annuallyRegistration?.percentage}%</strong>)
                        Compared to previous month
                      </>
                    }
                    date="just updated"
                    chart={annuallyRegistration}
                  />
                </MDBox>
              )}
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              {!isEmpty(sales) && (
                <MDBox mb={3}>
                  <ReportsLineChart
                    color="error"
                    title="Subscriptions"
                    description={
                      <>
                        (<strong>{sales?.percentage}%</strong>) Compared to
                        previous month
                      </>
                    }
                    date="just updated"
                    chart={sales}
                  />
                </MDBox>
              )}
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid>
            <MDBox
              bgColor="white"
              borderRadius="12px"
              mb={3}
              sx={{
                width: "100%",
                padding: 2, // padding inside the box
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <div style={{ width: "100%", maxWidth: "100%", padding: "16px" }}>
                <SimpleMap />
              </div>
            </MDBox>

            {/* <Grid item xs={12} md={6} lg={8}> */}
            <Projects />
            {/* </Grid> */}
            {/* <Grid item xs={12} md={6} lg={4}>
             <OrdersOverview /> 
              <SimpleMap />
            </Grid> */}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
